import { useMemo } from "react";
import { matchesQuery, buildPath } from "../lib/searchPath";

const STRENGTH_ORDER = { strong: 0, moderate: 1, weak: 2 };

export function useSearch(nodes, query) {
  return useMemo(() => {
    if (!query?.trim() || !nodes.length) return [];

    const nodeMap = new Map(nodes.map((n) => [n.id, n]));
    const youId = nodes.find((n) => n.degree === 0)?.id;
    const results = [];
    const seenTargets = new Set();

    nodes.forEach((node) => {
      // Only show degree-2 results — a warm intro via someone you already know.
      if (node.degree !== 2) return;
      if (!matchesQuery(node.profile, query)) return;
      if (seenTargets.has(node.id)) return;
      seenTargets.add(node.id);

      const { path } = buildPath(nodeMap, node, youId);
      const deg1Node = nodeMap.get(path[1]);
      results.push({ path, targetNode: node, deg1Node });
    });

    // Sort: shortest path first, then by degree-1 connection strength.
    results.sort((a, b) => {
      if (a.path.length !== b.path.length) return a.path.length - b.path.length;
      const as = STRENGTH_ORDER[a.deg1Node?.connectionStrength] ?? 2;
      const bs = STRENGTH_ORDER[b.deg1Node?.connectionStrength] ?? 2;
      return as - bs;
    });

    return results;
  }, [nodes, query]);
}
